
import React, { useEffect, useState } from 'react'
import { Item } from '../../../common/snippets'
import { ReportHeading } from '../common/ReportHeading'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import Datepicker from '../../../common/datePicker'
import { SplitButton } from '../../../common/SplitButton'
import { RefreshSvg } from '../../../common/svg/refresh'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { dispatchView, PDFHeaderColumnsForStationWise, PDFHeaderColumnsForVehicleWise } from './constant'
import moment from 'moment'
import { connect, useDispatch, useSelector } from 'react-redux'
import * as URL from '../../Reports/oldReportsUrls'
import { updateAlertError } from '../../../../store/common/common_action'
import { appendToUrl, focusElemnt, navigation3 } from '../../../common/helper'
import { getReceiptRegisterReportFilter } from '../../../../store/reports/reports_action'
import { urls } from '../../../common/constants'
import { GetRequest } from '../../../common/api'
import { useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { useAtom } from 'jotai'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../../helpers/useTokens'
import { companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms'
import { downloadPDF } from '../../Reports/analysisReport/pdfAutotable'

const ReceiptRegisterReport = (props) => {
  const paymentModesWithAll = [
    { id: 0, name: 'All' },
    { id: 1, name: 'Paid' },
    { id: 2, name: 'ToPay' },
  ]
  const dispatch = useDispatch();
  const state = useSelector((state) => state)
  const { common, reports } = state
  const { receiptRegisterFilterData } = reports
  const [selDispatchView, setSelDispatchView] = useState(dispatchView[0]);
  const [showReport, setShowReport] = useState(false);
  const [selReportView, setSelReportView] = useState([])
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [sourceCity, setSourceCity] = useState([])
  const [selSourceCity, setSelSourceCity] = useState('')
  const [sourceBranch, setSourceBranch] = useState([])
  const [selSourceBranch, setSelSourceBranch] = useState('')
  const [destinationCity, setDestinationCity] = useState([])
  const [selDestinationCity, setSelDestinationCity] = useState('')
  const [destinationBranch, setDestinationBranch] = useState([])
  const [selDestinationBranch, setSelDestinationBranch] = useState('')
  const [vehicleNoData, setVehicleNoData] = useState([])
  const [selVehicleNo, setSelVehicleNo] = useState('')
  const [paymentType, setPaymentType] = useState(paymentModesWithAll?.[0])
  const setLoader = useSetAtom(globalLoaderAtom)
  const setAlert = useSetAtom(alertAtom)
  const reportName = 'Receipt Register'
  
  const [companySettings] = useAtom(companySettingsAtom)
  const [searchParams] = useSearchParams()

  let { loginData = {} } = useToken()
  let isFromUrl = false
  if (!loginData) {
    loginData = {}
    loginData.intCompanyID = +searchParams.get('C') || 0        
    loginData.intUserID = +searchParams.get('U') || 0    
    loginData.strUserName = searchParams.get('UN') || ''
    loginData.strCompanyName = searchParams.get('CN') || ''
    loginData.strBranchName = searchParams.get('BN') || ''
    isFromUrl = true
  }
  const { intCompanyID, intUserID, strCompanyName } = loginData
  const UseToPayAsCOD = companySettings[0]?.UseToPayAsCOD

  const criteriaHeadersStationwise = [
    { field: 'FromDate', header: 'Dispatch From Date', textAlign: 'left' },
    { field: 'ToDate', header: 'Dispatch To Date', textAlign: 'left' },
    { field: 'FromCity', header: 'Dispatch From City', textAlign: 'left' },
    { field: 'FromBranch', header: 'Dispatch From Branch', textAlign: 'left' },
    { field: 'DispatchView', header: 'Dispatch View', textAlign: 'left' },
    { field: 'ToStation', header: 'To Station', textAlign: 'left' },
    { field: 'ToBranch', header: 'To Branch', textAlign: 'left' },
    { field: 'PaymentType', header: 'Payment Type', textAlign: 'left' },
  ]
  const criteriaDataStationwise = {
    FromDate: moment(fromDate).format("DD-MM-YYYY"),
    ToDate: moment(toDate).format("DD-MM-YYYY"),
    FromCity: selSourceCity?.FromCity,
    FromBranch: selSourceBranch?.FromBranch,
    DispatchView: selDispatchView?.name,
    ToStation: selDestinationCity?.ToCity,
    ToBranch: selDestinationBranch?.DestinationBranch,
    PaymentType: paymentType?.name,
    dataType: 'entry',
  }
  const criteriaHeadersVehiclewise = [
    { field: 'FromDate', header: 'Dispatch From Date', textAlign: 'left' },
    { field: 'ToDate', header: 'Dispatch To Date', textAlign: 'left' },
    { field: 'FromCity', header: 'Dispatch From City', textAlign: 'left' },
    { field: 'FromBranch', header: 'Dispatch From Branch', textAlign: 'left' },
    { field: 'DispatchView', header: 'Dispatch View', textAlign: 'left' },
    { field: 'VehicleNumber', header: 'Select Vehicle', textAlign: 'left' },
    { field: 'PaymentType', header: 'Payment Type', textAlign: 'left' },
  ]
  const criteriaDataVehiclewise = {
    FromDate: moment(fromDate).format("DD-MM-YYYY"),
    ToDate: moment(toDate).format("DD-MM-YYYY"),
    FromCity: selSourceCity?.FromCity,
    FromBranch: selSourceBranch?.FromBranch,
    DispatchView: selDispatchView?.name,
    ToStation: selDestinationCity?.ToCity,
    ToBranch: selDestinationBranch?.DestinationBranch,
    PaymentType: paymentType?.name,
    ReportView: selReportView?.name,
    VehicleNumber: selVehicleNo?.VehicleNo,
    dataType: 'entry',
  }
  useEffect(() => {
    const SourceCity = [
      { FromCityID: 0, FromCity: 'All' },
      ...[...new Map(receiptRegisterFilterData?.map((val) =>
        [val.FromCityID, { FromCityID: val.FromCityID, FromCity: val.FromCity }]
      )).values()]
    ];

    const SourceBranch = [
      { FromBranchID: 0, FromBranch: 'All' },
      ...[...new Map(receiptRegisterFilterData?.map((val) =>
        [val.FromBranchID, { FromBranchID: val.FromBranchID, FromBranch: val.FromBranch, FromCityID: val.FromCityID }]
      )).values()]
    ];

    const DestinationCity = [
      { ToCityID: 0, ToCity: 'All' },
      ...[...new Map(receiptRegisterFilterData?.map((val) =>
        [val.ToCityID, { ToCityID: val.ToCityID, ToCity: val.ToCity, FromCityID: val.FromCityID }]
      )).values()]
    ];

    const DestinationBranch = [
      { DestinationBranchID: 0, DestinationBranch: 'All' },
      ...[...new Map(receiptRegisterFilterData?.map((val) =>
        [val.DestinationBranchID, { DestinationBranchID: val.DestinationBranchID, DestinationBranch: val.DestinationBranch, ToCityID: val.ToCityID }]
      )).values()]
    ];

    const VehicleNoDropData = [
      ...[...new Map(receiptRegisterFilterData?.map((val) =>
        [val.VehicleID, { VehicleID: val.VehicleID, VehicleNo: val.VehicleNo }]
      )).values()]
    ];

    setSourceCity(SourceCity);
    setSourceBranch(SourceBranch);
    setDestinationCity(DestinationCity);
    setDestinationBranch(DestinationBranch);
    setVehicleNoData(VehicleNoDropData);
    setSelVehicleNo(VehicleNoDropData?.[0] || null);
  }, [receiptRegisterFilterData]);


  const callFilterAPI = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      const obj = {
        CompanyID: intCompanyID,
        DateFrom: moment(fromDate).format("YYYY-MM-DD"),
        DateTo: moment(toDate).format("YYYY-MM-DD")
      }
      dispatch(getReceiptRegisterReportFilter(obj))
      setSelSourceCity({ FromCityID: 0, FromCity: 'All' })
      setSelSourceBranch({ FromBranchID: 0, FromBranch: 'All' })
      setSelDestinationCity({ ToCityID: 0, ToCity: 'All' })
      setSelDestinationBranch({ DestinationBranchID: 0, DestinationBranch: 'All' })

    }
  }

  const handlekeyDown = (e, prevId, nextId, currentId, currentButton) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      document.getElementById(nextId).focus()
    } else if (e.key === 'Escape') {
      document.getElementById(prevId).focus()
    } else if (e.key === ' ') {
      if (currentButton === 'go') {
        callFilterAPI()
      } else {
        document.getElementById(currentId).click()
      }
    }
  }
  const toNumber = (val) => Number(val || 0);
  const toFixedValue = (val) => Number(toNumber(val).toFixed(2));
  
  const formatTableDataStationwise = (table = []) => {
    const formatted = table.map((item, index) => {
      const freight = toNumber(item.Freight);
      const freightGST = toNumber(item.F_S_Tax);

      const cartage = toNumber(item.Cartage);
      const cartageGST = toNumber(item.C_S_Tax);

      const hamali = toNumber(item.Hamali);
      const optHamali = toNumber(item.OptHamali);
      const optHamaliGST = toNumber(item.OptHamaliGST);

      const total =
        freight +
        freightGST +
        cartage +
        cartageGST +
        hamali +
        optHamali +
        optHamaliGST;

      return {
        ...item,
        SN: index + 1,
        dataType: "entry",
        Freight: toFixedValue(freight),
        F_S_Tax: toFixedValue(freightGST),
        Cartage: toFixedValue(cartage),
        C_S_Tax: toFixedValue(cartageGST),
        Hamali: toFixedValue(hamali),
        OptHamali: toFixedValue(optHamali),
        OptHamaliGST: toFixedValue(optHamaliGST),
        Total: toFixedValue(total)
      };
    });
    const totalsRow = formatted.reduce(
      (acc, item) => {
        acc.Qty += toNumber(item.Qty);
        acc.Freight += toNumber(item.Freight);
        acc.F_S_Tax += toNumber(item.F_S_Tax);

        acc.Cartage += toNumber(item.Cartage);
        acc.C_S_Tax += toNumber(item.C_S_Tax);

        acc.Hamali += toNumber(item.Hamali);
        acc.OptHamali += toNumber(item.OptHamali);
        acc.OptHamaliGST += toNumber(item.OptHamaliGST);
        acc.Total += toNumber(item.Total);

        return acc;
      },
      {
        SN: "",
        Branch: "Total",
        VehicleNo: "Total",
        dataType: "total",
        Qty: 0,
        Freight: 0,
        F_S_Tax: 0,
        Cartage: 0,
        C_S_Tax: 0,
        Hamali: 0,
        OptHamali: 0,
        OptHamaliGST: 0,
        Total: 0
      }
    );
    return [
      ...formatted,
      {
        ...totalsRow,
        Freight: toFixedValue(totalsRow.Freight),
        F_S_Tax: toFixedValue(totalsRow.F_S_Tax),
        Cartage: toFixedValue(totalsRow.Cartage),
        C_S_Tax: toFixedValue(totalsRow.C_S_Tax),
        Hamali: toFixedValue(totalsRow.Hamali),
        OptHamali: toFixedValue(totalsRow.OptHamali),
        OptHamaliGST: toFixedValue(totalsRow.OptHamaliGST),
        Total: toFixedValue(totalsRow.Total)
      }
    ];
  };
  const handleClick = (isPdf = false) => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      setShowReport(true)
      const obj = {
        intFromCityID: selSourceCity?.FromCityID,
        intFromBranchID: selSourceBranch?.FromBranchID,
        intToCityID: selDestinationCity?.ToCityID,
        intToBranchID: selDestinationBranch?.DestinationBranchID,
        intCompanyID: intCompanyID,
        dtFrom: moment(fromDate).format("YYYY-MM-DD"),
        dtTo: moment(toDate).format("YYYY-MM-DD"),
        intUserID: intUserID,
        intAmountType: paymentType?.id,
        ...(selDispatchView?.id === 1 ? {
          strVehicleNo: selVehicleNo?.VehicleNo,
          intVehicleID: selVehicleNo?.VehicleID
        } : {})
      };
      setLoader(true)
      GetRequest(urls.getReceiptRegisterReportTableData, obj)
        .then((res) => {
          setLoader(false)
          if (res.status !== 'Success') {
            throw new Error(res?.ErrMessage || 'Invalid Response')
          }
          if (!res.Table1.length) {
            setAlert({ show: true, msg: 'No Data Found!', nextId: '' })
          }
          let reportPayload = {}
          if (selDispatchView.id === 0) {
            let tableData1 = formatTableDataStationwise(res?.Table1)
            let headers = PDFHeaderColumnsForStationWise.map((a) => ({
              ...a,
              field: a.field,
              align: a.align,
              weight: 80
            }))
            reportPayload = {
              reportName,
              criteriaHeaders: criteriaHeadersStationwise,
              criteriaData: [criteriaDataStationwise],
              tableData: tableData1,
              mainHeader: headers,
            }
            if (isPdf === true) {
              downloadPDF({
                reportName,
                criteriaHeaders: criteriaHeadersStationwise,
                criteriaData: [criteriaDataStationwise],
                tableData: tableData1,
                visibleColumns: headers,
                loginData,
                hideHeader: false,
              })
              return
            }
          } else if (selDispatchView.id === 1) {
            let tableData1 = formatTableDataStationwise(res?.Table1)
            let headers = PDFHeaderColumnsForVehicleWise.map((a) => ({
              ...a,
              field: a.field,
              align: a.align,
              weight: 80
            }))
            reportPayload = {
              reportName,
              criteriaHeaders: criteriaHeadersVehiclewise,
              criteriaData: [criteriaDataVehiclewise],
              tableData: tableData1,
              mainHeader: headers,
            }
            if (isPdf === true) {
              downloadPDF({
                reportName,
                criteriaHeaders: criteriaHeadersVehiclewise,
                criteriaData: [criteriaDataVehiclewise],
                tableData: tableData1,
                visibleColumns: headers,
                loginData,
                hideHeader: false,
              })
              return
            }
          }

          const rid = Date.now().toString()
          if (!window.generatedReports) {
            window.generatedReports = {}
          }
          window.generatedReports[rid] = reportPayload
          window.open(`/view-report?rid=${rid}`, "_blank")
        })
        .catch((error) => {
          setAlert({ show: true, msg: error.message, nextId: '' })
        })
    }
  }
  const handleClick2 = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      let url = URL.ReceiptRegisterReportStationWise
      let urlData = URL.ReceiptRegisterReportStationWiseParams
      urlData.chk = loginData.BusCrsCheckSum
      urlData.intFromCityID = selSourceCity?.FromCityID
      urlData.intFromBranchID = selSourceBranch?.FromBranchID
      urlData.intToBranchid = selDestinationBranch?.DestinationBranchID
      urlData.intAmountType = paymentType?.id
      urlData.strVehicleNo = selDispatchView?.id === 0 ? 0 : selVehicleNo?.VehicleNo
      urlData.dtfromDate = moment(fromDate).format("DD-MMM-YYYY")
      urlData.dtToDate = moment(toDate).format("DD-MMM-YYYY")
      urlData.intVehicleID = selDispatchView?.id === 0 ? 0 : selVehicleNo?.VehicleID
      urlData.strFromCityName = selSourceCity?.FromCity
      urlData.strFromBranchName = selSourceBranch?.FromBranch
      urlData.strToBranchName = selDestinationBranch?.DestinationBranch
      urlData.intVehicleChk = selDispatchView?.id === 0 ? 0 : 1
      urlData.intAllowExportToExcel = 1
      url = appendToUrl(url, urlData)
      window.open(url, '_blank')
    }
  }

  useEffect(() => {
    focusElemnt('fromDate')
  }, [])

  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
        {!isFromUrl && <ReportHeading reportName={reportName} />}
        <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px', ...(!isFromUrl && { background: '#fff', borderBottom: '1px solid #ccc', paddingBottom: '10px' }), }}>
          {!isFromUrl && <>
            <Item sx={sx.itemsx}>
              <DropDownOA
                id="selectCompnay"
                prevId={'generateDiv'}
                nextId={'ArrowForwardIosIcon1'}
                label={'Company Name'}
                defaultvalue={strCompanyName}
                disabled={true}
                width="100%"
              />
            </Item>
            <Item
              tabIndex={0}
              id="ArrowForwardIosIcon1"
              sx={sx.itemsx}
              className="disabled-wrapper"
              variant="contained"
              disabled={true}
              style={{ ...sx.novp, display: 'flex', justifyContent: 'center', width: '4%', backgroundColor: '#CCC' }}
            >
              <ArrowForwardIosIcon id="ArrowForwardIosIcon1Btn" />
            </Item>
          </>}
          <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_collection_date'}
              label={`Dispatch From Date`}
              id="fromDate"
              nextId={'toDate'}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt('toDate')
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
            <Datepicker
              name={'to_dispatch_date'}
              label={'Dispatch To Date'}
              id="toDate"
              nextId={'ArrowForwardIosIcon2'}
              prevId={'fromDate'}
              dateChange={(date) => {
                setToDate(date)
                focusElemnt('ArrowForwardIosIcon2')
              }}
              width="100%"
            />
          </Item>
          <Item
            tabIndex={0}
            id="ArrowForwardIosIcon2"
            sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}
            className="enable-wrapper"
            variant="contained"
            onKeyDown={(e) => handlekeyDown(e, 'fromDate', 'dispatchByBranch', 'ArrowForwardIosIconBtn', 'go')}
            style={{
              display: 'flex',
              justifyContent: 'center',
              width: '4%',
              color: 'white',
              backgroundColor: '#fe5200',
              borderRadius: '4px',
            }}
          >
            <ArrowForwardIosIcon id="ArrowForwardIosIconBtn" onClick={callFilterAPI} />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={'Dispatch From City'}
              id="dispatchByBranch"
              nextId={'destination'}
              prevId={'ArrowForwardIosIcon2'}
              data={sourceCity}
              dataKey={`FromCity`}
              idKey={`FromCityID`}
              defaultvalue={selSourceCity?.FromCity || selSourceCity}
              isObjArr={true}
              onSelect={(val) => setSelSourceCity(val)}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={'Dispatch From Branch'}
              id="destination"
              nextId={'destinationBranch'}
              prevId={'dispatchByBranch'}
              data={sourceBranch || []}
              dataKey={`FromBranch`}
              idKey={`FromBranchID`}
              defaultvalue={selSourceBranch?.FromBranch || selSourceBranch}
              onSelect={(val) => { setSelSourceBranch(val) }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={'Dispatch View'}
              id="destinationBranch"
              nextId={selDispatchView?.name === 'Station Wise' ? 'toStation' : 'vehicleList'}
              prevId={'destination'}
              data={dispatchView}
              dataKey={`name`}
              idKey={`id`}
              onSelect={(val) => {
                setShowReport(false)
                setSelDispatchView(val)
              }}
              defaultvalue={selDispatchView?.name || selDispatchView}
              width="100%"
            />
          </Item>
          {
            selDispatchView?.name === 'Station Wise' ?
              <>
                <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                  <DropDownOA
                    label={'To Station'}
                    id="toStation"
                    defaultvalue={selDestinationCity?.ToCity || ''}
                    data={destinationCity || []}
                    dataKey={`ToCity`}
                    idKey={`ToCityID`}
                    onSelect={(val) => { setSelDestinationCity(val) }}
                    nextId={'toBranch'}
                    prevId={'destinationBranch'}
                    width="100%"
                  />
                </Item>
                <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                  <DropDownOA
                    label={'To Branch'}
                    id="toBranch"
                    defaultvalue={selDestinationBranch?.DestinationBranch || selDestinationBranch}
                    data={destinationBranch || []}
                    dataKey={`DestinationBranch`}
                    idKey={`DestinationBranchID`}
                    onSelect={(val) => { setSelDestinationBranch(val) }}
                    nextId={'paymentType'}
                    prevId={'toStation'}
                    width="100%"
                  />
                </Item>
                <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                  <DropDownOA
                    label={'Payment Type'}
                    data={(paymentModesWithAll || []).map((item) => {
                      if (UseToPayAsCOD === 1) {
                        if (item.id === 2) {
                          return { ...item, name: 'COD' };
                        }
                      }
                      return item;
                    }).filter(Boolean)
                    }
                    id="paymentType"
                    nextId={'generateBtn'}
                    prevId={'toBranch'}
                    defaultvalue={paymentType?.name || ''}
                    width="100%"
                    searchPlaceholder={`Search By Payment Type`}
                    tabIndex="2"
                    dataKey={`name`}
                    idKey={`id`}
                    onSelect={(val) => {
                      setPaymentType(val)
                    }}
                  />
                </Item>
              </>
              :
              <>

                <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                  <DropDownOA
                    label={'Select Vehicle'}
                    id="vehicleList"
                    defaultvalue={selVehicleNo?.VehicleNo || ''}
                    value={selVehicleNo?.VehicleNo || ''}
                    data={vehicleNoData || []}
                    dataKey={`VehicleNo`}
                    idKey={`VehicleID`}
                    onSelect={(val) => { setSelVehicleNo(val) }}
                    nextId={'paymentType'}
                    prevId={'destinationBranch'}
                    width="100%"
                  />
                </Item>
                <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                  <DropDownOA
                    label={'Payment Type'}
                    data={(paymentModesWithAll || []).map((item) => {
                      if (UseToPayAsCOD === 1) {
                        if (item.id === 2) {
                          return { ...item, name: 'COD' };
                        }
                      }
                      return item;
                    }).filter(Boolean)
                    }
                    id="paymentType"
                    nextId={'generateBtn'}
                    prevId={'vehicleList'}
                    defaultvalue={paymentType?.name || ''}
                    width="100%"
                    searchPlaceholder={`Search By Payment Type`}
                    tabIndex="2"
                    dataKey={`name`}
                    idKey={`id`}
                    onSelect={(val) => {
                      setPaymentType(val)
                    }}
                  />
                </Item>
              </>
          }
          {isFromUrl ?
            <Button variant="contained" sx={{ width: '100%', height: '40px' }} className="btn btn-primary" onClick={() => handleClick(true)} id1={'generateBtn'}>
              DOWNLOAD PDF
            </Button> :
            <>
              <Item
                id="generateDiv"
                tabIndex={0}
                sx={sx.itemsx}
                onKeyDown={(e) => navigation3(e, showReport ? "DispatchPrintBtn" : 'fromDate', 'paymentType', () => handleClick())}
              >
                <SplitButton
                  options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                  prevId={'paymentType'}
                  id1={'generateBtn'}
                  nextId={'fromDate'}
                  onClick1={handleClick}
                  onClick2={handleClick2}
                  disabled={false}
                />
              </Item>
              <Item sx={{ ...sx.itemsx, display: 'none' }}>
                <RefreshSvg />
              </Item>
            </>}
        </Box>
      </Item>
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateAlertError }
export default connect(mapStateToProps, mapDispatchToProps)(ReceiptRegisterReport)
